import { NearbyStore } from "../types";

const getActiveStoreId = (activeStore: NearbyStore): string | null => {
  const fullId = activeStore.childLocationIds?.DEPTMS;
  if (!fullId) {
    return null;
  }

  return /\d+/.exec(fullId)?.[0].slice(-5) ?? null;
};

export default getActiveStoreId;
